export default {
  baseStyle: {
    fontWeight: 500,
    color: 'white',
  },
};
